
/**
 * https://domain1.icode.org.cn        -> https://domain2.icode.org.cn 
 * https://domain1-test.icode.org.cn        -> https://domain2-test.icode.org.cn 
 * https://domain1.icode4good.com        -> https://domain2.icode4good.com 
 */

export function getOriginUrl(domain1, domain2) {
    // 临时使用
    if(window.location.origin == "https://ide-test.icode.org.cn" && domain2 === "service") {
        return "https://service-dev.icode.org.cn";
    }

    let domainNames = window.location.origin.split('.');
    domainNames[0] = domainNames[0].replace(domain1, domain2);
    return domainNames.join(".");    
}


// WEBPACK FOOTER //
// ./src/utils/domain.js